import React from "react";
import Amplify from 'aws-amplify';

import { MainView } from "./components/mainView.js";
import { authConfig } from "./configures/awsConfig.js";

Amplify.configure({
  Auth: authConfig
});

class App extends React.Component {
  render() {
    return (
      <MainView />
    );
  }
}

export default App;
